import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
} from "reactstrap";
import {
  GET_METER_MONTH_CONF,
  GET_METER_MONTH_DATA,
  baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";
import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
//i18n

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}


function ViewerMeteringMonthDetail(props) {

  let history = useHistory();
  let { pid } = useParams();

  const dispatch = useDispatch();

  const permission = getPermission();
  const searchObj = { UPLOADCONF_PID: pid, METER_NAME: "", METER_TYPE: "", ZONE_NAME: "", AREA_NAME: "" };
  const pidInfoMeteringMonthly = { PID: pid };

  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [dataDetail, setDataDetail] = useState({});
  const [searchModel, setSearchModel] = useState(searchObj);

  const listData = [
    {
      Id: "1",
      Date: "25/09/2021",
      Shipper: "Capacity",
      ContactCode: " ",
      Area: "A1",
      Booking: "1,770,000",
    },
    {
      Id: "2",
      Date: "22/09/2021",
      Shipper: "EGAT",
      ContactCode: "2021-CSF-005",
      Area: "A1",
      Booking: "1,014,000",
    },
    {
      Id: "3",
      Date: "20/09/2021",
      Shipper: "EGAT",
      ContactCode: "2021-CSF-005",
      Area: "A2",
      Booking: "116,000",
    },
    {
      Id: "4",
      Date: "19/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "B",
      Booking: "128,350",
    },
    {
      Id: "5",
      Date: "18/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "C1",
      Booking: "127,620",
    },
    {
      Id: "6",
      Date: "17/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "C2",
      Booking: "302,510",
    },
    {
      Id: "7",
      Date: "17/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "D",
      Booking: "54,000",
    },
    {
      Id: "8",
      Date: "01/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "E",
      Booking: "116,000",
    },
    {
      Id: "9",
      Date: "01/09/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      Area: "Y",
      Booking: "1,128,050",
    },
  ]

  const gotoPageMaster = () => {
    // history.push("/metering-data-monthly");
    history.push({
      pathname: "/viewer-metering-month", state: {  // location state
        goBack: true,
      },
    });
  };

  //sort Column//
  const defaultSorted = [{
    dataField: 'METER_NAME',
    order: 'asc'
  }];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ]
  };

  //Sort Page//


  // Action Button//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => (rowIndex + 1)
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "4%",
        fontSize: "12px",
      },
      style: {
        width: "4%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "LOAD_DATE",
      text: "Gas Day",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "7%",
        fontSize: "12px",
      },
      style: {
        width: "7%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.LOAD_DATE, "DD/MM/YYYY"),
    },
    {
      dataField: "METER_NAME",
      text: "Metering Point ID",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "ZONE_NAME",
      text: "Zone",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "7%",
        fontSize: "12px",
      },
      style: {
        width: "7%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "AREA_NAME",
      text: "Area",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "7%",
        fontSize: "12px",
      },
      style: {
        width: "7%",
        fontSize: "12px",
      },
      sort: true,
    },

    {
      dataField: "METER_TYPE",
      text: "Customer Type",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "12%",
        fontSize: "12px",
      },
      style: {
        width: "12%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "VOLUME",
      text: "Volume (MMSCF)",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => numberFormat(row.VOLUME, 3),
    },
    {
      dataField: "HEATING",
      text: "Heating Value (BTU/SCF)",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        width: "11%",
        fontSize: "12px",
      },
      style: {
        width: "11%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => numberFormat(row.HEATING, 3),
    },
    {
      dataField: "ENERGY",
      text: "Energy (MMBTU)",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => numberFormat(row.ENERGY, 3),
    },

    // {
    //   dataField: "SQL_DATE",
    //   text: "Received Timestamp",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "11%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "11%",
    //   },
    //   // sort: true,
    //   isDummyField: true,
    //   formatter: (cellContent, row) => FormatDate(row.SQL_DATE, "DD/MM/YYYY, HH:mm:ss"),
    // },

    // {
    //   dataField: "SOURCE_DATE",
    //   text: "TPA Insert Timestamp",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "11%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "11%",
    //   },
    //   sort: true,
    //   isDummyField: true,
    //   formatter: (cellContent, row) => FormatDate(row.SOURCE_DATE, "DD/MM/YYYY, HH:mm:ss"),
    // },

    // {
    //   dataField: "SOURCE_NAME",
    //   text: "Data Source",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {},
    //   sort: true,
    // },

  ];
  //headerColumn


  //onInit//
  useEffect(function () {
    resetSearch();

    ///fixed header table
    let tableId = "viewer-metering-month-detail-table";
    let scrollY = 214;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };


  }, [])
  //onInit//

  const downloadExcel = () => {
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/downloadExcelMeterMonthFile?UPLOADCONF_PID=" + pid, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          // dataDetail.UPLOAD_FILE
          dataDetail.UPLOAD_FILE != null && dataDetail.UPLOAD_FILE != "" && dataDetail.UPLOAD_FILE != undefined ?
            dataDetail.UPLOAD_FILE : "Metering( Monthly )_" + dataDetail.SOURCE_NAME + "_" + moment(dataDetail.UPLOAD_DATE).format("DD-MM-YYYY") + ".xlsx"
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
    getDataDetail();
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  const getDataDetail = async () => {
    // dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_METER_MONTH_CONF, { pid });
      // console.log(res);
      setDataDetail(res.data.uploadDataList[0]);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    // dispatch(loadingAction.hideLoading());
  };

  const fetchData = async (searchData) => {
    // console.log(searchData);
    const objSearch = {
      ...(searchData.METER_NAME != '') && { METER_NAME: searchData.METER_NAME },
      ...(searchData.METER_TYPE != '') && { METER_TYPE: searchData.METER_TYPE },
      ...(searchData.ZONE_NAME != '') && { ZONE_NAME: searchData.ZONE_NAME },
      ...(searchData.AREA_NAME != '') && { AREA_NAME: searchData.AREA_NAME },
      UPLOADCONF_PID: searchData.UPLOADCONF_PID
    }
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_METER_MONTH_DATA, objSearch);
      // console.log(res);
      setModelDeviceList(res.data.uploadDataList);
    } catch (error) {
      // console.log(err);
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>

                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Metering Data Detail ( Monthly )")}
                    </h1>

                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item"><Link to="#" style={{ color: '#556ee6' }}>Report Viewer</Link></li>
                        <li className="breadcrumb-item"><Link to="/viewer-metering-month" style={{ color: '#556ee6' }}>Metering Data ( Monthly )</Link></li>
                        <li className="breadcrumb-item active">Metering Data Detail ( Monthly )</li>
                      </ol>
                    </div>
                  </div>

                  <div>
                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Gas Day : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{moment(dataDetail.UPLOAD_START).locale('en').format(
                      "MMM-YYYY"
                    )}</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Data Source : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{dataDetail.SOURCE_NAME}</span>
                  </div>
                  <hr />

                  <Row>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Metering Point ID
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Metering Point ID")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    METER_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.METER_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Zone
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Zone")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    ZONE_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.ZONE_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Area
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Area")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    AREA_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.AREA_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Communication Type
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Communication Type")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    METER_TYPE: e.target.value,
                                  })
                                }
                                value={searchModel.METER_TYPE}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="2">
                      <FormGroup className="row">
                        <div className="d-flex align-items-center justify-content-end">
                          <Button color="info" className="mt-3" onClick={() => onSearch()}>
                            <i className="fas fa-search"></i>
                            &nbsp; Search
                          </Button>

                          <Button color="warning" className="mt-3 ms-2" onClick={() => resetSearch()}>
                            <i className="fas fa-redo-alt"></i>
                            &nbsp; Reset
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="mb-2 mt-3">
                    <Col sm="3">
                      <div className="d-grid gap-2 d-md-block">
                        {permission.vRVM && (
                          <Button
                            onClick={() =>
                              downloadExcel()
                            }
                            // className="btn-rounded"
                            color="success"
                            className="mt-2 mb-2"
                          >
                            <i className="fas fa-file-download fa-lg"></i>
                            &nbsp; Download Excel
                          </Button>
                        )}
                      </div>
                    </Col>
                    <Col sm="9" className="d-flex align-items-center justify-content-end">
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          onClick={() =>
                            gotoPageMaster()
                          }
                          // className="btn-rounded"
                          color="secondary"
                          className="mt-2 mb-2"
                        >
                          <i className="fas fa-angle-double-left"></i>
                          &nbsp; Back
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div>
                        <BootstrapTable
                          id="viewer-metering-month-detail-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

          </Row>
        </Container>

      </div>
    </React.Fragment >
  );

}

ViewerMeteringMonthDetail.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ ViewerMeteringMonthDetail }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ViewerMeteringMonthDetail));


// function RenderList(prop) {
  //   console.log(prop);

  //   return (<tr>
  //     <td>{prop.indexlist}</td>
  //     <td>{prop.data.MeterPointID}</td>
  //     <td>{prop.data.Customer}</td>
  //     <td>{prop.data.CustomerType}</td>
  //     <td>{prop.data.CommunicationType}</td>
  //     <td>{prop.data.Zone}</td>
  //     <td>{prop.data.Point}</td>
  //     <td>{prop.data.Region}</td>
  //     <td>{prop.data.Area}</td>
  //     <td>{prop.data.BVZoning}</td>
  //     <td>{prop.data.BV}</td>
  //     <td>
  //       <Button className="me-1"
  //         onClick={() =>
  //           setPageAdd(true)
  //         }
  //         color="info"
  //       >
  //         <i className="far fa-edit"></i>
  //         &nbsp; Edit
  //       </Button>
  //       <Button
  //         onClick={() =>
  //           setModalDelete(true)
  //         }
  //         // className="btn-rounded"
  //         color="danger"
  //       >
  //         <i className="fas fa-trash-alt"></i>
  //         &nbsp; Delete
  //       </Button>
  //     </td>
  //   </tr>)
  // }